const isValidColor = (hex: string) => {
  let regex = "^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$";
  return hex.match(regex);
}

export default isValidColor;